import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import StravaAuth from './components/StravaAuth';
import StravaCallback from './components/StravaCallback';
import ActivityGrid from './features/ActivityGrid/ActivityGrid';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<StravaAuth />} />
          <Route path="/callback" element={<StravaCallback />} />
          <Route path="/dashboard" element={<ActivityGrid />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
